import React from 'react';

import { RightPanel } from '@jira/design-system__navigation-system/src/PageLayout.tsx';
import { PanelRouter, PanelsRenderer, usePanelManager } from '@atlassian/panel-system';
// import { PanelSplitter } from '@atlaskit/navigation-system';

export const RightAdsPanel = (): React.JSX.Element | null => {
	const { state } = usePanelManager();

	return state.activePanels.length ? (
		<RightPanel testId="page-container-v2.common.ui.right-ads-panel.dst-panel">
			<PanelsRenderer>
				<PanelRouter />
			</PanelsRenderer>
			{/* <PanelSplitter
			label={formatMessage(messages.previewPanelSplitterLabel)}
			onResizeEnd={onResizeEnd}
			testId="dst.panel-splitter"
		/> */}
		</RightPanel>
	) : null;
};
